import { useLeadForm } from '../context/LeadFormContext';

export default function CtaButton({
  children,
  className = 'btn btn-primary',
  onClick,
  type = 'button',
  ...props
}) {
  const { openLeadForm } = useLeadForm();

  const handleClick = (event) => {
    onClick?.(event);
    openLeadForm();
  };

  return (
    <button type={type} className={className} onClick={handleClick} {...props}>
      {children}
    </button>
  );
}
